import _get from 'lodash/get';
import GqlClient from 'utils/graphqlService';
import GetHomeTopicsQuery from './Topics.gql';

const getTrendingTopics = async (_key, limit, clientDetails, localeFilters) => {
  const excludedTopics = (
    _get(clientDetails, 'excludeTopicCollection.items') || []
  )
    .map(({ slug }) => slug)
    .filter(item => !!item);
  const response = await GqlClient.query({
    query: GetHomeTopicsQuery,
    variables: {
      limit,
      ...localeFilters,
      excludedTopics,
    },
  });
  return response;
};

export default getTrendingTopics;
